<template>
	<div class="tpl my-appointment-wrap">
		<mt-header title="我的约会" fixed>
		  <router-link :to="{'name':'appointment-list'}" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		  <mt-button class="header-right-btn"  icon="more" slot="right"><img src="../../assets/img/finds/ic_find_nav_select@2x.png"/></mt-button>
		</mt-header>
		<div class="appointment-list-header">
			<mt-navbar v-model="selected">
				<mt-tab-item id="1">我的邀约<span class="active-dot"></span></mt-tab-item>
				<mt-tab-item id="2">我的应约<span class="active-dot"></span></mt-tab-item>
			</mt-navbar>
		</div>

		<!-- tab-container -->
		<mt-tab-container v-model="selected">
			<mt-tab-container-item id="1" class="my-invitation">
				<div class="my-invitation-list">
					<mt-loadmore :top-method="refreshInvitationList" :bottom-method="loadMoreInvitationList" :auto-fill="false" ref="invitationLoadmore">
				  		<ul>
				  			<li v-for="item in invitationList" :class="{'over-time':item.status==2}"  @click="goToAppointmentDetail(item.r_id,item.uid)">
				  				<div class="item-header">
				  					<span class="item-name"><img src="../../assets/img/finds/ic_list_other@2x.png"/>{{item.name}} <span v-if="item.name=='其它'">（{{item.other}}）</span></span>
				  					<span class="item-time">倒计时 {{item.release_time|toDateTime|relativeTime}}</span>
				  				</div>
				  				<div class="item-join">
				  					<div class="item-join-members">
				  						<div class="join-imgs">
											<img v-for="i in item.sign" :src="i.avatar" alt="" />
										</div>
										<span class="join-num">{{item.sign&&item.sign.length>3?'+'+item.sign.length-3:"无"}}人应约</span>
				  					</div>
				  					<div class="item-btn">
				  						<button><img src="../../assets/img/finds/ic_find_list_more@2x.png"/></button>
				  					</div>
				  				</div>
				  				<div class="item-status">
				  					<span class="item-create-time">{{item.release_time | toDateTime | convertTime("YYYY-DD-MM hh:mm")}}</span>
				  					<span class="item-status-text">
				  						<span v-if="item.status==0">暂未成功</span>
				  						<span v-if="item.status==1">已成功</span>
				  						<span v-if="item.status==2">已失败</span>
				  						<span v-if="item.status==3">取消约会</span>
				  						<span v-if="item.status==4">已同意</span>
				  					</span>
				  				</div>
				  			</li>
				  		</ul>
					</mt-loadmore>
				</div>
			</mt-tab-container-item>
			<mt-tab-container-item id="2">
				<div class="my-accept-list">
					<mt-loadmore :top-method="refreshAcceptList" :bottom-method="loadMoreAcceptList" :auto-fill="false" ref="acceptLoadmore">
				  		<ul>
				  			<li v-for="item in acceptList">
				  				<div class="item-sender">
				  					<div class="user-info">
				  						<div class="user-img">
				  							<img :src="item.avatar"/>
				  						</div>
				  						<div class="user-name">
				  							<p class="user-nickname">{{item.nickname}}</p>
				  							<p class="user-age">{{item.age}}岁 
				  								<img v-if="item.gender==1" src="../../assets/img/common/ic_user_man@2x.png"/>
				  								<img v-if="item.gender==2" src="../../assets/img/common/ic_user_woman@2x.png"/>
				  							</p>
				  						</div>
				  						<div class="item-status">
				  							<img src="../../assets/img/finds/ic_find_list_pick@2x.png"/>
				  							<span v-if="item.status==0">申请中</span>
					  						<span v-if="item.status==1">成功</span>
					  						<span v-if="item.status==2">失败</span>
					  						<span v-if="item.status==3">发布方取消约会</span>
					  						<span v-if="item.status==4">取消约会</span>
				  						</div>
				  					</div>
				  					<div class="item-btn">
				  						<button><img src="../../assets/img/finds/ic_find_list_more@2x.png"/></button>
				  					</div>
				  				</div>
				  				<div class="item-intro">
				  					<div class="item-type">
				  						<span><img src="../../assets/img/finds/ic_list_other@2x.png"/>{{item.name}}</span>
				  						<span><img src="../../assets/img/finds/ic_find_list_time@3x.png"/>{{item.release_time | toDateTime | convertTime("YYYY-MM-DD")}}</span>
				  					</div>
				  					<div class="item-act-btn">
				  						<button v-if="item.status==0" @click="cancelAccept(item.r_id)">取消应约</button>
				  						<button v-else @click="goToChatting">去聊聊</button>
				  					</div>
				  				</div>
				  			</li>
				  		</ul>
					</mt-loadmore>
				</div>
			</mt-tab-container-item>
		</mt-tab-container>
	</div>
</template>

<script>
	export default{
		name:"my-appointment",
		data(){
			return{
				uid:"",
				selected:"1",
				invitationNowPage:1,	//邀约当前页码
				invitationStatus:"-1",
				acceptNowPage:1,	//应约当前页码
				invitationList:[],	//我的邀约列表
				acceptList:[],	//我的应约列表
			}
		},
		watch:{
			selected(){
				if(this.selected==1){
					this.getInvitationList();
				}else if(this.selected==2){
					this.getAcceptList();
				}
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed","finds");		//属于finds模块
			this.$store.commit("changeTabBarShow",false);	//不显示navbar
			
			this.getInvitationList();
		},
		methods:{
			//邀约列表
			getInvitationList(){
				this.$axios({
					url:"Appointment/MyAppointment",
					method:"post",
					data:{
						uid:this.uid,
						page:this.invitationNowPage,
						status:this.invitationStatus
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						if(this.invitationNowPage==1){
							this.invitationList = res.data.data;
						}else{
							if(res.data.data.length<1){
								this.$toast({
									message:"没有更多内容了~",
									position:"bottom",
									duration:3000
								})
								this.invitationNowPage--;
							}else{
								this.invitationList = this.invitationList.concat(res.data.data);
							}
						}
					}else{
						this.$toast({
							message:"没有更多内容了~",
							position:"bottom",
							duration:3000
						})
						this.invitationNowPage--;
					}
				})
				.catch(err=>{
					console.log(err);
					this.$indicator.close();
					this.$toast({
						message:"加载超时，请重试",
						position:"bottom",
						duration:3000
					})
				})
			},
			//应约列表
			getAcceptList(){
				this.$axios({
					url:"Appointment/Byappointment",
					method:"post",
					data:{
						uid:this.uid,
						page:this.acceptNowPage,
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						if(this.acceptNowPage==1){
							this.acceptList = res.data.data;
						}else{
							if(res.data.data.length<1){
								this.$toast({
									message:"没有更多内容了~",
									position:"bottom",
									duration:3000
								})
								this.acceptNowPage--;
							}else{
								this.acceptList = this.invitationList.concat(res.data.data);
							}
						}
					}else{
						this.$toast({
							message:"没有更多内容了~",
							position:"bottom",
							duration:3000
						})
						this.acceptNowPage--;
					}
				})
				.catch(err=>{
					console.log(err);
					this.$indicator.close();
					this.$toast({
						message:"加载超时，请重试",
						position:"bottom",
						duration:3000
					})
				})
			},
			//取消应约
			cancelAccept(id){
				this.$axios({
					url:"Appointment/CancelTheContract",
					method:"post",
					data:{
						r_d_id:id,
						uid:this.uid
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({
							message:res.data.msg,
							position:"bottom",
							duration:3000
						});
						this.getAcceptList();
					}else if(res.data.code==400){
						this.$toast({
							message:res.data.msg,
							position:"bottom",
							duration:3000
						})
					}
				}).catch(err=>{
					console.log(err);
					this.$indicator.close();
					this.$toast({
						message:"加载超时，请重试",
						position:"bottom",
						duration:3000
					})
				})
			},
			//进入约会详情页
			goToAppointmentDetail(id,uid){
				console.log(this.uid,id,uid);
				if(uid == this.uid){
					this.$router.push({
						name:"appointment-mine",
						query:{
							id:id
						}
					})
				}else{
					this.$router.push({
						name:"appointment-other",
						query:{
							id:id
						}
					})
				}
			},
			goToChatting(){
				this.$router.push({
					name:"chatting"
				})
			},
			refreshInvitationList(){
				this.invitationNowPage = 1;
				this.getInvitationList();
				this.$refs.invitationLoadmore.onTopLoaded();
			},
			loadMoreInvitationList(){
				this.invitationNowPage++;
				this.getInvitationList();
				this.$refs.invitationLoadmore.onBottomLoaded();
			},
			refreshAcceptList(){
				this.acceptNowPage = 1;
				this.getAcceptList();
				this.$refs.acceptLoadmore.onTopLoaded();
			},
			loadMoreAcceptList(){
				this.acceptNowPage++;
				this.getAcceptList();
				this.$refs.acceptLoadmore.onBottomLoaded();
			},
		}
	}
</script>

<style scoped>
	.my-appointment-wrap{
		padding-top: 5.5rem;
		background: #fff;
	}
	.header-right-btn img{
		width: 1.5rem;
	}
	.appointment-list-header{
		border-bottom: 1px solid #f3f3f3;
		position: fixed;
		width: 100%;
		top: 2.5rem;
		left: 0;
		z-index: 10;
		background: #fff;
	}
	
	.mint-navbar {
		width: 50%;
	}
	
	>>>.mint-navbar .mint-tab-item {
		box-sizing: border-box;
		position: relative;
	}
	
	.active-dot{
	    display: none;
	    width: 5px;
	    height: 5px;
	    background: #6D34FB;
	    border-radius: 50%;
	    position: absolute;
	    left: 50%;
	    bottom: 0.4rem;
	}
	
	
	>>>.mint-tab-item.is-selected .mint-tab-item-label {
		font-size: 1rem;
		font-weight: bold;
		color: #282828;
	}
	
	>>>.mint-tab-item.is-selected .active-dot{
		display: block;
	}
	
	>>>.mint-navbar .mint-tab-item.is-selected {
		border-bottom: 0;
	}
	.my-invitation{
		background: #fafafa;
	}
	
	.my-invitation-list,
	.my-accept-list{
		height: 100%;
		overflow-y: scroll;
	}
	.my-invitation-list ul{
		padding:0 1rem;
	}
	.my-invitation-list li{
		padding: 1rem;
	    background: #fff;
	    margin: 1rem 0;
	    box-shadow: 2px 3px 10px 0px rgba(129,87,247,.3);
	    border-radius: 5px;
	}
	
	.my-invitation-list li.over-time{
		filter: grayscale(100%);
		opacity: 0.5;
	}
	
	.my-invitation-list .item-header{
		display: flex;
	    justify-content: space-between;
	    align-items: center;
	}
	.my-invitation-list .item-header .item-name{
		flex: 1;
		display: flex;
	    justify-content: flex-start;
	    align-items: center;
	    font-size: 0.8rem;
	    color: #282828;
	    font-weight: bold;
	}
	.my-invitation-list .item-header .item-name img{
		width: 1.5rem;
		margin-right: 0.3rem;
	}
	.my-invitation-list .item-header .item-time{
	    font-size: 0.8rem;
    	color: red;
	}
	.my-invitation-list .item-join{
		display: flex;
		padding: 1rem 0;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #f3f3f3;
		margin-bottom: 0.5rem;
	}
	.my-invitation-list .join-members{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.my-invitation-list .join-imgs img{
		width: 2.5rem;
		border-radius: 50%;
		display: inline-block;
		border: 3px solid #fff;
	}
	.my-invitation-list .join-imgs img:nth-of-type(2){
		position: relative;
		left: -10%;
	}
	.my-invitation-list .join-imgs img:nth-of-type(3){
		position: relative;
		left: -20%;
	}
	.my-invitation-list .join-num{
		font-size: 0.9rem;
		color: #282828;
	}
	.my-invitation-list .item-btn button{
		outline: 0;
		background: none;
		border: 0;
	}
	.my-invitation-list .item-btn img{
		width: 1rem;
	}
	.my-invitation-list .item-status{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 0.8rem;
		color: #9e9e9e;
	}
	
	.my-accept-list li{
		padding: 1rem;
		border-bottom: 1px solid #f3f3f3;
	}
	.my-accept-list .item-sender{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.my-accept-list .item-sender .user-info{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex: 1;
	}
	.my-accept-list .item-sender .user-name{
		font-size: 0.8rem;
		color: #282828;
		line-height: 2rem;
		padding: 0 1rem;
	}
	.my-accept-list .item-sender .user-img img{
		width: 3.2rem;
		display: block;
		border-radius: 5px;
	}
	.my-accept-list .item-sender .user-age,
	.my-accept-list .item-sender .item-status{
		font-size: 0.65rem;
		color: #7b7b7b;
		line-height: 1.2rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.my-accept-list .item-sender .user-age img,
	.my-accept-list .item-sender .item-status img{
		width: 1.5rem;
	}
	.my-accept-list .item-sender .item-btn button{
		border: 0;
		outline: 0;
		background: none;
	}
	.my-accept-list .item-sender .item-btn button img{
		width: 1.2rem;
	}
	.my-accept-list .item-intro{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem 0 0;
	}
	.my-accept-list .item-type,
	.my-accept-list .item-type span{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 0.65rem;
		color: #9e9e9e;
	}
	.my-accept-list .item-type span{
		margin-right: 0.5rem;
	}
	.my-accept-list .item-type img{
	    width: 1.2rem;
    	margin-right: 0.2rem;
	}
	.my-accept-list .item-act-btn button{
		font-size: 0.85rem;
	    padding: 0.3rem 1rem;
	    border: 1px solid rgba(84,21,249,.7);
	    background: none;
	    border-radius: 2rem;
	    color: #7644FA;
	    outline: 0;
	}
	.my-accept-list .item-act-btn button:active{
		background: #7644FA;
		color: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/MyAppointment.vue